module.exports = __webpack_public_path__ + "static/img/3.3a0061a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/3.png
// module id = TMUH
// module chunks = 0